import { Component, Input, OnInit } from '@angular/core';
import { OpenModalService } from '../../services/open-modal/open-modal.service';
import { FaqModalComponent } from './faq-modal/faq-modal.component';

@Component({
  selector: 'app-dialog-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: false
})
export class FaqComponent implements OnInit {
  textContent: string;

  @Input()
  id?: string;

  @Input()
  buttonStyle: 'default' | 'textOnly';

  @Input()
  position: 'right' | 'center';

  constructor(private readonly _openModalService: OpenModalService) {}

  ngOnInit() {
    if (!this.id) {
      this.id = 'default';
    }
  }

  showFaq() {
    this._openModalService.openModal(
      FaqModalComponent,
      { id: this.id },
      { maxWidth: '', maxHeight: '', panelClass: ['no-padding-dialog-container', 'full-width-dialog-container'] }
    );
  }
}
